export default __webpack_public_path__ + "static/media/cryptoTreasuryLogo.bce61e9d.svg";